"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.durationBetweenCellRenderer = void 0;
const react_1 = __importDefault(require("react"));
require("moment");
const components_1 = require("@veeam/components");
require("@veeam/components/lib/Grid/types");
const constants_1 = require("../../../constants");
require("../../../core");
const getFormattedDuration_1 = require("../../../helpers/utils/getFormattedDuration");
require("../types");
const durationCellRenderer_1 = require("./durationCellRenderer");
function durationBetweenCellRenderer(_a) {
    var { startName, stopName, unit = getFormattedDuration_1.UNIT_OF_TIME.milliseconds, emptyValue = constants_1.EMPTY_TEXT.dash, headerJustify = components_1.GRID_COLUMN_HEADER_JUSTIFY.left } = _a, otherConfigProps = __rest(_a, ["startName", "stopName", "unit", "emptyValue", "headerJustify"]);
    return (_a) => {
        var { rowData } = _a, otherProps = __rest(_a, ["rowData"]);
        const startTime = rowData[startName];
        const stopTime = rowData[stopName];
        const start = new Date(startTime);
        const stop = new Date(stopTime);
        const diff = startTime && stopTime ? stop.getTime() - start.getTime() : 0;
        return diff === 0 ? (react_1.default.createElement("span", null, emptyValue)) : (durationCellRenderer_1.durationCellRenderer({
            unit,
            emptyValue,
            headerJustify,
        })(Object.assign(Object.assign(Object.assign({}, otherProps), otherConfigProps), { rowData, cellData: diff })));
    };
}
exports.durationBetweenCellRenderer = durationBetweenCellRenderer;
//# sourceMappingURL=durationBetweenCellRenderer.js.map